// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "ce172fe55486a8edf0f7f16b822b2ded" + ".js";
};